import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import Icon from '../icons/Icon';
import { ICONS } from '../icons';

const isRouteActive = (pathname, url, selectedRoutes = []) => pathname === url || selectedRoutes.includes(pathname);

const SidebarItem = ({
  label,
  icon,
  url,
  pathname,
  isStrokeIcon,
  selectedRoutes = [],
  disabled,
  items,
  slim,
  onExpandSidebar,
}) => {
  const childRoutes = (items || []).map((child) => child.url);
  const hasChildren = Boolean(items?.length);
  const childActive = childRoutes.includes(pathname);
  const isActive = isRouteActive(pathname, url, selectedRoutes) || childActive;
  const [isExpanded, setIsExpanded] = useState(childActive);

  useEffect(() => {
    if (childActive) {
      setIsExpanded(true);
    }
  }, [childActive]);

  const handleGroupClick = () => {
    if (slim) {
      onExpandSidebar?.();
      setIsExpanded(true);
      return;
    }
    setIsExpanded((prev) => !prev);
  };

  if (hasChildren) {
    return (
      <li className={clsx('sidebar-group', isExpanded && !slim && 'sidebar-group--expanded')}>
        <button
          type='button'
          className={clsx('nav-link', 'nav-link--group', isActive && 'nav-link--group-active')}
          onClick={handleGroupClick}
          aria-expanded={isExpanded && !slim}>
          <span className='nav-link_icon-wrapper'>
            <Icon
              icon={icon}
              size={18}
              className={clsx('nav-link_icon', isStrokeIcon && 'nav-link_icon--stroke')}
              disableCommonColors
            />
          </span>
          <span className='nav-link_label'>{label}</span>
          <Icon
            icon={ICONS.CaretUp}
            size={10}
            disableCommonStyles
            currentColor
            className={clsx('nav-link_caret', isExpanded && !slim && 'nav-link_caret--open')}
          />
        </button>

        {!slim && isExpanded ? (
          <ul className='sidebar-submenu'>
            {items.map((child) => (
              <li key={child.url || child.label}>
                <Link
                  className={clsx(
                    'nav-link',
                    'nav-link--child',
                    child.disabled && 'nav-link--disabled',
                    pathname === child.url && 'nav-link--active',
                  )}
                  to={child.url}>
                  <span className='nav-link_icon-wrapper'>
                    <Icon
                      icon={child.icon}
                      size={16}
                      className={clsx('nav-link_icon', child.isStrokeIcon && 'nav-link_icon--stroke')}
                      disableCommonColors
                    />
                  </span>
                  <span className='nav-link_label'>{child.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        ) : null}
      </li>
    );
  }

  return (
    <li>
      <Link
        className={clsx(
          'nav-link',
          disabled && 'nav-link--disabled',
          isRouteActive(pathname, url, selectedRoutes) && 'nav-link--active',
        )}
        to={url}>
        <span className='nav-link_icon-wrapper'>
          <Icon
            icon={icon}
            size={18}
            className={clsx('nav-link_icon', isStrokeIcon && 'nav-link_icon--stroke')}
            disableCommonColors
          />
        </span>
        <span className='nav-link_label'>{label}</span>
      </Link>
    </li>
  );
};

export default SidebarItem;
